import { render, staticRenderFns } from "./AlipayAnxinCard.vue?vue&type=template&id=6b461ea6&scoped=true"
import script from "./AlipayAnxinCard.vue?vue&type=script&lang=js"
export * from "./AlipayAnxinCard.vue?vue&type=script&lang=js"
import style0 from "./AlipayAnxinCard.vue?vue&type=style&index=0&id=6b461ea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b461ea6",
  null
  
)

export default component.exports